export function useRecipientDrop(getForm) {
  const handleRecipientDrop = ({ item, sourceField, targetField }) => {
    if (sourceField === targetField) return;

    const form = getForm();

    const fieldMap = {
      to: form.to,
      cc: form.cc,
      bcc: form.bcc,
    };

    const sourceArray = fieldMap[sourceField];
    const targetArray = fieldMap[targetField];

    if (!sourceArray || !targetArray) return;

    if (!targetArray.includes(item)) {
      targetArray.push(item);
    }
    const idx = sourceArray.indexOf(item);
    if (idx > -1) {
      sourceArray.splice(idx, 1);
    }

    form.to = [...form.to];
    form.cc = [...form.cc];
    form.bcc = [...form.bcc];
  };

  return { handleRecipientDrop };
}
